import React from 'react';
// Components
import Articles from './Articles/Articles';

const AllArticles: React.FC = () => {
  return <Articles />;
};

export default AllArticles;
